const TENANT_PLACEMENT_COOKIES = {
  HAS_CLICKED_DASHBOARD_POST: 'ZRM_hasClickedReactivateListing',
  HAS_CLICKED_ADD_PROPERTY_MODAL_POST: 'ZRM_hasClickedPostNewListing',
  HAS_CLOSED_BANNER: 'ZRM_hasClosedDashboardBanner',
  EXPIRATION: 30,
} as const;

const CLAIM_YOUR_LISTING_COOKIES = {
  HAS_CLOSED_MODAL: 'ZRM_hasClosedClaimYourListingsModal',
  HAS_CLOSED_CLAIM_BANNER: 'ZRM_hasClosedClaimYourListingsBanner',
  HAS_CLOSED_UPGRADE_BANNER: 'ZRM_hasClosedUpgradeToAdPackageBanner',
  HAS_CLOSED_CLAIM_MORE_BANNER: 'ZRM_hasClosedClaimMoreListingsBanner',
  HAS_CLOSED_CLAIM_MORE_MODAL: 'ZRM_hasClosedClaimMoreListingsModal',
  EXPIRATION: 400, // max expiration date
};

export { TENANT_PLACEMENT_COOKIES, CLAIM_YOUR_LISTING_COOKIES };
